var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 23.863 24.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface_Filter_filled",
    "data-name": "Interface / Filter filled",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.863,6.386A3.7,3.7,0,0,0,27.7,4.814a1.489,1.489,0,0,0-.651-.652A3.71,3.71,0,0,0,25.476,4H6.386a3.7,3.7,0,0,0-1.572.163,1.491,1.491,0,0,0-.652.652A3.707,3.707,0,0,0,4,6.386v1.1a3.192,3.192,0,0,0,.041.719,1.491,1.491,0,0,0,.179.431,3.194,3.194,0,0,0,.479.537l7.551,7.551a3.173,3.173,0,0,1,.478.537,1.494,1.494,0,0,1,.18.431,3.138,3.138,0,0,1,.041.708v7.093c0,1.278,0,1.918.269,2.3a1.491,1.491,0,0,0,1,.62c.465.069,1.037-.217,2.18-.789l1.193-.6a3.32,3.32,0,0,0,.893-.538,1.49,1.49,0,0,0,.345-.556,3.334,3.334,0,0,0,.082-1.04V18.411a3.193,3.193,0,0,1,.041-.719,1.489,1.489,0,0,1,.179-.431,3.148,3.148,0,0,1,.474-.532l.005,0,7.551-7.551a3.186,3.186,0,0,0,.478-.537,1.494,1.494,0,0,0,.18-.431,3.145,3.145,0,0,0,.041-.708Z",
    transform: "translate(-4 -4)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPrimaryIcon);
export default __webpack_public_path__ + "static/media/filter-primary-icon.55e8acfb13121a2c9c06aac7fdf9a289.svg";
export { ForwardRef as ReactComponent };